(function($) {
  /**
   * Message Slider
   */
  if ($('.message-slider').length) {
    $('.message-slider').each(function() {
      $(this).slick({
        autoplay: true,
        autoplaySpeed: 8000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        cssEase: 'ease-in-out',
        dots: true,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              adaptiveHeight: true,
            },
          },
        ],
      });
    });
  }
})(jQuery);
